export const ooraTomtomTrafficReducer = (state = {}, action) => {
  switch (action.type) {
    // LIST
    case "GET_OORA_TOMTOM_TRAFFIC_LIST_REQUEST":
      return { ...state, loading: true, listLoading: true };

    case "GET_OORA_TOMTOM_TRAFFIC_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        listLoading: false,
        ooraTomtomTrafficList: action.payload,
        listError: null,
      };

    case "GET_OORA_TOMTOM_TRAFFIC_LIST_FAILED":
      return { ...state, loading: false, listLoading: false, listError: action.payload };

    // SINGLE (VIEW)
    case "GET_OORA_TOMTOM_TRAFFIC_REQUEST":
      return { ...state, loading: true, singleLoading: true, singleError: null };

    case "GET_OORA_TOMTOM_TRAFFIC_SUCCESS":
      return {
        ...state,
        loading: false,
        singleLoading: false,
        ooraTomtomTraffic: action.payload,
        singleError: null,
      };

    case "GET_OORA_TOMTOM_TRAFFIC_FAIL":
      return { ...state, loading: false, singleLoading: false, singleError: action.payload };

    case "RESET_OORA_TOMTOM_TRAFFIC":
      return { ...state, ooraTomtomTraffic: null, singleError: null, listError: null };

    default:
      return state;
  }
};